import React, { createContext, useContext } from 'react';

import Firebase from '../helpers/Firebase';

const FirebaseContext = createContext(null);

const useFirebase = () => useContext(FirebaseContext);

const FirebaseProvider = ({ children }) => (
  <FirebaseContext.Provider value={Firebase}>
    {children}
  </FirebaseContext.Provider>
);


export { FirebaseContext, FirebaseProvider, useFirebase };
